import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type AgentWithTimeFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AgentWithTimeFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: AgentWithTimeFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-4.724854 -4.218653) scale(1.741619)',
        },
        [
          h(
            'path',
            {
              "fill-rule": 'evenodd',
              "clip-rule": 'evenodd',
              d: 'M5.08163 6.04898V9.09796C4.21837 9.09796 3.52041 8.41837 3.53265 7.57959C3.53265 7.00408 3.85102 6.50816 4.32857 6.2449C4.99592 4.35918 6.82653 3 8.98776 3C11.1429 3 12.9735 4.35306 13.6469 6.2449C14.1184 6.50816 14.4429 7.0102 14.4429 7.57959C14.4429 8.41837 13.7449 9.10408 12.8816 9.10408V6.04898C12.9245 6.04898 12.9673 6.04898 13.0102 6.0551C12.3184 4.5551 10.7755 3.50816 8.98163 3.50816C7.18776 3.50816 5.6449 4.5551 4.95306 6.0551C4.99592 6.04898 5.03878 6.04898 5.08163 6.04898ZM10.6331 11.8706C10.116 12.0498 9.55976 12.1469 8.98163 12.1469C7.68367 12.1469 6.49592 11.6571 5.61429 10.849C4.03469 11.651 3 13.0653 3 14.9878H11.0959C10.6833 14.4312 10.4392 13.7421 10.4392 12.9961C10.4392 12.6012 10.5076 12.2223 10.6331 11.8706ZM8.98164 4.52344C7.1143 4.52344 5.60205 6.00507 5.60205 7.82956C5.60205 9.65405 7.1143 11.1357 8.98164 11.1357C10.849 11.1357 12.3612 9.65405 12.3612 7.82956C12.3551 6.00507 10.8429 4.52344 8.98164 4.52344ZM9.00001 9.73976C8.43674 9.73976 7.97756 9.40303 7.97756 8.9867H10.0225C10.0225 9.40303 9.56328 9.73976 9.00001 9.73976ZM10.9055 12.9745C10.9055 11.5131 12.0944 10.3242 13.5558 10.3242C15.0172 10.3242 16.2061 11.5131 16.2061 12.9745C16.2061 14.4359 15.0172 15.6248 13.5558 15.6248C12.0944 15.6248 10.9055 14.4359 10.9055 12.9745ZM13.3674 13.3531H14.498C14.6025 13.3531 14.6873 13.2685 14.6873 13.1638C14.6873 13.0593 14.6026 12.9745 14.498 12.9745H13.5558V11.6558C13.5558 11.5513 13.471 11.4665 13.3665 11.4665C13.262 11.4665 13.1772 11.5513 13.1772 11.6558V13.1628C13.1772 13.2675 13.2629 13.3531 13.3674 13.3531Z',
            },
          ),
        ],
      ),
    ],
  );

export default AgentWithTimeFilled;
